export default __webpack_public_path__ + "static/media/icon-settings-white.fde9b5b2.svg";